<h3 color="primary" class="popup-header">Issues</h3>
<mat-dialog-content class="mat-typography">
  <ejs-grid [dataSource]='dataList' [enableInfiniteScrolling]='true' [allowFiltering]="true" [allowResizing]="true"
    [pageSettings]="pageSettings">
    <e-columns>
      <e-column field='key' headerText='Issue Id' width=30></e-column>
      <e-column field='priority' headerText='Priority' width=30>
        <ng-template #template let-data>
          {{data?.fields?.priority?.name}}
        </ng-template>
      </e-column>
      <e-column field='status' headerText='Status' width=30>
        <ng-template #template let-data>
          {{data?.fields?.status?.name}}
        </ng-template>
      </e-column>
      <e-column field='created' headerText='Date' width=30>
        <ng-template #template let-data>
          {{data?.fields?.created | date:"MM/dd/yyyy h:mm a"}}
        </ng-template>
      </e-column>
      <e-column field='summary' headerText='Summary' width=30>
        <ng-template #template let-data>
          {{data?.fields?.summary}}
        </ng-template>
      </e-column>
      <e-column field='customfield_10400' headerText='Reported By' width=30>
        <ng-template #template let-data>
          {{data?.fields?.customfield_10400}}
        </ng-template>
      </e-column>
      <e-column field='id' headerText='Action' width="20" textAlign='Center' [allowFiltering]="false">
        <ng-template #filterTemplate let-data></ng-template>
        <ng-template #template let-data>
          <button mat-icon-button color="primary" matTooltip="Edit" (click)="addEditIssue(data)">
            <mat-icon>edit</mat-icon>
          </button>
        </ng-template>
      </e-column>
    </e-columns>
  </ejs-grid>
  <app-total-record-count [count]="dataList.length"></app-total-record-count>
</mat-dialog-content>
<mat-dialog-actions class="popup-footer">
  <button mat-raised-button color="primary" (click)="addEditIssue()">
    <i class="fas fa-plush"></i> Add Issue
  </button>
  <button mat-raised-button color="warn" (click)="cancelClick()">
    <i class="fas fa-times"></i> Close
  </button>
</mat-dialog-actions>